import { render, staticRenderFns } from "./DispatchLoadOrders.vue?vue&type=template&id=94c68a2a&"
import script from "./DispatchLoadOrders.vue?vue&type=script&lang=js&"
export * from "./DispatchLoadOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports